import React from 'react';
import { LightContainer, Flex, FlexColumn } from '../../Reusable/Container'
import { Checkbox } from 'antd';
import { Text } from '../../Reusable/Text'
import { TextButton } from '../../Reusable/Button'
import { LabeledInput } from '../../Reusable/Input'
import AionIcon from '../../../Images/aion-bank-icon.png'
import { toCurrency, getBPAccountsWithAccess, getFeaturePerm, getFeatureLimit } from '../../../Utils/util'

const AutoDebitCard = ({
    autoDebitEnabled,
    fromAccount,
    options,
    handleChange,
    handleSelectAccount,
    toggleOnlinePayment,
    selectedCustomer,
    onViewPaymentMethods,
}) => {
    const autoDebitPercent = parseFloat(getFeatureLimit("BusinessBanking.Fees.AutoDebitPercentFee"))
    const autoDebitCap = parseFloat(getFeatureLimit("BusinessBanking.Fees.AutoDebitCapFee"))

    console.log("AutoDebitCardselectedCustomer", selectedCustomer)

    return (
        <LightContainer className="radio-table" fullWidth>
            <Flex start style={{ cursor: 'pointer', marginBottom: 16 }} onClick={toggleOnlinePayment}>
                <Checkbox disabled={selectedCustomer && !selectedCustomer?.validPaymentMethod} checked={autoDebitEnabled} onChange={handleChange} />
                <FlexColumn style={{ margin: '0 0 0 8px' }} gap="8px">
                    <Text size="16px" weight={autoDebitEnabled ? '700' : '400'}>Auto-debit payment</Text>
                    <Text lightText>The default payment method for each customer will be used to automatically debit the invoice amount on the due date</Text>
                </FlexColumn>
            </Flex>

            {autoDebitEnabled && (
                <FlexColumn start gap="24px" style={{ marginBottom: 0 }}>
                    {
                        (!selectedCustomer || selectedCustomer?.validPaymentMethod) &&
                        <>
                            <Flex start style={{ paddingRight: 0 }}>
                                <LabeledInput
                                    nomargin
                                    label="Where would you like to receive payment?"
                                    type="select"
                                    id="fromAccount"
                                    placeholder="Select account"
                                    value={fromAccount && (
                                        <Flex between centerHorizontally style={{ height: 30 }}>
                                            <Text>
                                                <img
                                                    width="16px"
                                                    height="16px"
                                                    src={AionIcon}
                                                    style={{ marginRight: 8, marginBottom: 2 }}
                                                    alt="Aion"
                                                />
                                                {`${fromAccount.nickName || `Business ${fromAccount.accountSubType}`} • ${fromAccount.mask}`}
                                            </Text>
                                            <Text size="14px" lightText style={{ marginLeft: 8 }}>
                                                ${toCurrency(fromAccount.availableBalance)}
                                            </Text>
                                        </Flex>
                                    )}
                                    onChange={handleSelectAccount}
                                >
                                    {options}
                                </LabeledInput>
                            </Flex>

                            <LabeledInput
                                nomargin
                                label="Fees"
                                type="read-only"
                                placeholder="Select account"
                                value={`${autoDebitPercent}% of the payment amount${(autoDebitCap && autoDebitCap > 0) ? `, capped at $${autoDebitCap}` : ""}`}
                            />
                        </>
                    }

                    {
                        (selectedCustomer && !selectedCustomer?.validPaymentMethod) &&
                        <FlexColumn start gap="8px">
                            <Text>You need a verified payment method for {selectedCustomer?.displayName} to activate this option.</Text>
                            <TextButton text="View Payment Methods" onClick={onViewPaymentMethods} />
                        </FlexColumn>
                    }
                </FlexColumn>
            )}
        </LightContainer>
    );
};

export default AutoDebitCard;
